import { Link, Message, RadioField, RadioInput } from '@flos/react-ui';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useUpdateCoverableInformation } from '../../../../../recoil/hooks/useUpdateCoverableInformation';
import { useHippoText } from '../../../../../hooks/useHippoText';
import DOMPurify from 'dompurify';
import CallMeModal from '../../../../../shared_components/CallMeModal/CallMeModal';
import ViewInformationModal from '../../../../../shared_components/ViewInformationModal/ViewInformationModal';

const HouseRentalQuestion = (): React.JSX.Element => {
    const getHippoText = useHippoText();
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const houseCoverables = coverables.houses ?? [];
    const coverableIndex = houseCoverables?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const currentHouseCoverable = houseCoverables[coverableIndex];
    const [showCallMeModal, setShowCallMeModal] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);

    const handleChoiceChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = event.target;
        updateCoverableInformation({
            rental: value
        });
        if (value === 'Yes') {
            setShowCallMeModal(true);
        }
    };

    return (
        <div className="u-spacing-inset-m--stretch-max">
            <h4>{getHippoText('DSS-ADDITIONAL-INFORMATION-RENTING-TITLE')}</h4>
            <Message
                id={`rental-info-label-${currentHouseCoverable.fixedId}`}
                className="coverage-warning paragraph--small u-spacing-stack-s"
                title={
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                                getHippoText('DSS-ADDITIONAL-INFORMATION-RENTING-INFORMATION')
                            )
                        }}
                    />
                }
            />
            <RadioField value={currentHouseCoverable.rental ?? ''} onChange={handleChoiceChange}>
                <RadioInput label={'Ja'} value="Yes" />
                <RadioInput label={'Nej'} value="No" />
            </RadioField>
            <Link
                onClick={() => {
                    setShowModal(true);
                }}
                theme="logo"
            >
                {getHippoText('DSS-ADDITIONAL-INFORMATION-INFOLINK')}
            </Link>
            {showModal && (
                <ViewInformationModal
                    showModal={showModal}
                    modalProps={{
                        title: getHippoText('DSS-ADDITIONAL-INFORMATION-INFOLINK'),
                        description: getHippoText('DSS-ADDITIONAL-INFORMATION-INFOLINK-RENTING')
                    }}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
            {showCallMeModal && (
                <CallMeModal
                    activityCode="dss_call_request"
                    showModal={showCallMeModal}
                    closeModal={() => {
                        setShowCallMeModal(false);
                    }}
                    title={getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-HEADER')}
                    description={
                        getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-SUBHEADER') +
                        ' ' +
                        getHippoText('DSS-CALL-ME-MODAL-NO-PRICE-BOOK-CALL-SUBHEADER')
                    }
                />
            )}
        </div>
    );
};

export default HouseRentalQuestion;
